<script setup>
const props = defineProps(["class"]);
</script>

<template>
    <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="class"
    >
        <path
            d="M16.75 4H14.5V3.25C14.5 3.05109 14.421 2.86032 14.2803 2.71967C14.1397 2.57902 13.9489 2.5 13.75 2.5H6.25C6.05109 2.5 5.86032 2.57902 5.71967 2.71967C5.57902 2.86032 5.5 3.05109 5.5 3.25V4H3.25C3.05109 4 2.86032 4.07902 2.71967 4.21967C2.57902 4.36032 2.5 4.55109 2.5 4.75V7C2.5 10.2325 3.85 12.1825 6.115 12.25C6.44548 12.8215 6.89764 13.3132 7.43943 13.6904C7.98121 14.0676 8.59935 14.3209 9.25 14.4325V16H7.75V17.5H12.25V16H10.75V14.4325C11.4007 14.3209 12.0188 14.0676 12.5606 13.6904C13.1024 13.3132 13.5545 12.8215 13.885 12.25C16.135 12.175 17.5 10.225 17.5 7V4.75C17.5 4.55109 17.421 4.36032 17.2803 4.21967C17.1397 4.07902 16.9489 4 16.75 4ZM4 7V5.5H5.5V10.6225C4.165 10.06 4 7.975 4 7ZM14.5 10.6225V5.5H16V7C16 7.975 15.835 10.06 14.5 10.6225Z"
            fill="currentColor"
        />
    </svg>
</template>
